import React from "react";
import {
  LoaderWrapper,
  SpinnerContainer,
  SpinnerRing,
  SpinnerRingInner,
  LoadingText,
} from "./styles";
import { useTranslation } from "react-i18next";

interface Props {
  show?: boolean;
}

const Loader: React.FC<Props> = ({ show = true }: Props) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <LoaderWrapper>
      <SpinnerContainer>
        <SpinnerRing>
          <SpinnerRingInner />
        </SpinnerRing>
        <LoadingText>{t("LOADING_DATA") || t("LOADING") || "טוען נתונים..."}</LoadingText>
      </SpinnerContainer>
    </LoaderWrapper>
  );
};

export default Loader;
